import React, {useState} from 'react'
import {NavLink} from 'react-router-dom'
import AnimateHeight from 'react-animate-height'
import cn from 'classnames'

/** @param {import("./Tag").TagProps} props */
export default function Tag(props) {
    const [height, setHeight] = useState(/** @type {number | string} */ (0)) // просто 0

    const toggleChildren = () => {
        setHeight(height === 0 ? 'auto' : 0)
    }

    const {
        tag: {name, path, icon, color, position, parametrazedName},
        children,
        handleClick,
    } = props

    return (
        <>
            <div
                className={cn('tag', {
                    tag_open: height,
                })}
                onClick={toggleChildren}
            >
                {position < 10 && icon && (
                    <i className={icon.style} style={{color: icon.color}} data-testid={icon.style} />
                )}
                <NavLink
                    exact
                    to={path}
                    onClick={handleClick && handleClick(parametrazedName)}
                    style={position < 10 && color ? {color} : {}}
                >
                    {name}
                </NavLink>
            </div>
            <If condition={children}>
                <AnimateHeight duration={300} height={height}>
                    <div className="tag-children">{children}</div>
                </AnimateHeight>
            </If>
        </>
    )
}
